import { createFileRoute, redirect } from "@tanstack/react-router";

// Plant guides are canonically served at /articles/:slug; /plants/:slug is a
// permanent alias. The /plants hub itself (plants/index.tsx) is unaffected.
export const Route = createFileRoute("/plants/$slug")({
  beforeLoad: ({ params }) => {
    throw redirect({ href: `/articles/${params.slug}`, statusCode: 301 });
  },
});
